import { render, staticRenderFns } from "./home.vue?vue&type=template&id=4c24dc80&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=4c24dc80&lang=stylus&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24dc80",
  null
  
)

export default component.exports